import {
  extractSalary,
  formattedRate,
  formatCurrency
} from "../../../../components/common/Converter";
import {
  calculate,
  calculateArray,
  getSumContributions,
  getSumCsvData,
  getTotalNetOfMandatory,
  // getExactNetOfMandatory,
  getTaxableAllowances,
  createLookup,
  getDaysInMonth,
  // calculateBackPay,
  groupAndSumByMonth,
  sumObjContributions,
  calculateAmount,
  extractDayNumbers,
  getSumAdditional,
  getRangeInSelectedDate,
  // getInServiceCount,
  excludeLeaveFromAbsences,
  // getActualAttendanceDates,
  extractYearMonth,
  formatAbsenceDates,
  _calculateAmountRoundDown,
  getDefaultOfDuty,
  parseTwentyFourSevenHours,
  getMatchedCsvRowByAgency
} from "../helper-payroll/HelperFunction";
import {
  isAddendumBackPayItem,
  isBackPayItem,
} from "../helper-payroll/constants/payrollConstants";

export const calculations = (
  objects,
  selectedTypes,
  requestLists,
  otherInfo,
  datePicked,
  value = "",
  updatedObj,
  salaryGradeList,
  processedAttendance
) => {
  const {processedLogs = {}, lookupData = {}} = processedAttendance;

  console.log("updatedObj", updatedObj);
  const { jobTypeVal, payItems, payrollTypes } = selectedTypes;
  const {
    csv,
    numberOfDutiesinAP,
    // monthIndex,
    natureOfFunction,
    monthFrom,
    monthTo,
  } = otherInfo;
  const airport = [];

  console.log("csvvvvv data", csv);

  console.log("numberOfDutiesinAP", numberOfDutiesinAP);

  const rawStartDate = datePicked?.startDate;
  const dateObj = new Date(rawStartDate);

  const formatted = `${dateObj.toLocaleString("en-US", {
    month: "long",
  })} - ${dateObj.getFullYear()}`;

  const daysInMonth = getDaysInMonth(datePicked || {});

  const payrollCode = otherInfo?.payrollCode;

  // const taxes = requestLists?.extractedTaxes ?? [];
  const allowances = requestLists?.allowanceLists?.allowance ?? [];
  const contributions = requestLists?.contributionListMap ?? [];
  const mandatoryFormula = requestLists?.mandatoryFormula ?? {};
  const contributionName = requestLists?.contributionName ?? {};
  const hasIncentives =
    Array.isArray(requestLists?.incentives) &&
    requestLists.incentives.length > 0;

  const otherAdditional = hasIncentives
    ? requestLists.incentives[0].otherAdditionals
    : undefined;
  const otherDeductions = hasIncentives
    ? requestLists.incentives[0].otherDeductions
    : undefined;


  // const sumContributions = getSumContributions(contributions, "specific");
  const sumallContributions = getSumContributions(contributions, "all");
  const sumallAdditional = getSumAdditional(otherAdditional, csv);
  const sumallDeductions = getSumAdditional(otherDeductions, csv);

  // console.log("contributions", contributions);

  // console.log("sumallContributions", sumallContributions);

  // const sumObjectContributions

  const sumCsvData = getSumCsvData(csv, "all");
  const taxFromCsv = getSumCsvData(csv, "tax");
  const taxPercentFromCsv = getSumCsvData(csv, [2, 5, 10]);
  const deductionsFromCsv = getSumCsvData(csv, [2, 5, 10], { exclude: true });

  // const sumTaxableAllowance = getTaxableAllowances(allowances, "Yes");
  // const gratuityAllowance = getTaxableAllowances(
  //   allowances,
  //   "No",
  //   "GRATUITY PAY"
  // );

  const rataAllowance = getTaxableAllowances(allowances, "No", "RATA");
  const daysToBeDeduc = createLookup(updatedObj, "id", "daysToBeDeducted");
  // const halfdaysDeduc = createLookup(updatedObj, "id", "halfDaysToBeDeducted");
  // const minsToBeDeduc = createLookup(updatedObj, "id", "minutesToBeDeducted");
  const minsToBeDeducted = createLookup(updatedObj, "id", "minsToBeDeducted");

  const absentCountById = createLookup(updatedObj, "id", "absentCount");
  const halfDayCountById = createLookup(updatedObj, "id", "halfDayCount");
  const workingDaysSetArrayById = createLookup(updatedObj, "id", "workingDaysSetArray");
  const leaveWithoutPaySetArrayById = createLookup(updatedObj, "id", "leaveWithoutPaySetArray");
  const workingDaysCountById = createLookup(updatedObj, "id", "workingDaysCount");
  const absentDatesById = createLookup(updatedObj, "id", "absentDates");
  const halfDayDatesById = createLookup(updatedObj, "id", "halfDayDates");
  const totalLateUTMinsById = createLookup(updatedObj, "id", "totalLateUTMins");
  const lateCountById = createLookup(updatedObj, "id", "lateCount");
  const dateOfFlagRaisingById = createLookup(updatedObj, "id", "lateDates");
  const minutesIncurredById = createLookup(updatedObj, "id", "minutesIncurred");
  const holidaysById = createLookup(updatedObj, "id", "holidays");
  const suspensionsById = createLookup(updatedObj, "id", "suspensions");


  const daysInaMonth = createLookup(updatedObj, "id", "daysInAMonth");
  const periodCount = createLookup(updatedObj, "id", "updatedCountPrd");
  const overPaymentBasic = createLookup(updatedObj, "id", "overpaymentBasic");
  const overPaymentPera = createLookup(updatedObj, "id", "overpaymentPeraAda");
  const ovrPayment = createLookup(updatedObj, "id", "overpayment");
  const flgRaising = createLookup(updatedObj, "id", "flagRaising");
  const apRateAmount = createLookup(updatedObj, "id", "apRate");
  const basicSalaryAmount = createLookup(updatedObj, "id", "basicSalary");
  const updatedTax = createLookup(updatedObj, "id", "tax");
  const lateCount = createLookup(updatedObj, "id", "lateCount");

  const three = createLookup(updatedObj, "id", "3");
  const two = createLookup(updatedObj, "id", "2");
  const five = createLookup(updatedObj, "id", "5");
  const ten = createLookup(updatedObj, "id", "10");

  const numOfDays = createLookup(updatedObj, "id", "noOfDays");
  const basicArr = createLookup(updatedObj, "id", "basic");
  const taxArr = createLookup(updatedObj, "id", "tax");
  const monthNamesArr = createLookup(updatedObj, "id", "monthNamesArr");

  const gsisLR = createLookup(updatedObj, "id", "gsisLR");
  const phic = createLookup(updatedObj, "id", "phic");
  const pagibigArr = createLookup(updatedObj, "id", "pagibig");
  const dutyForCiaMciaBinoc = createLookup(
    updatedObj,
    "id",
    "OfDutyForCiaMciaBinocRangeTo1519"
  );
  const dutyForCiaMciaBinoc2 = createLookup(
    updatedObj,
    "id",
    "OfDutyForCiaMciaBinocRangeTo15192"
  );
  const daysDeducForReg = createLookup(updatedObj, "id", "abs");
  const minsDeducForReg = createLookup(updatedObj, "id", "latesUt");
 
  // const minsToDeducAirport = createLookup(
  //   airport,
  //   "employeeId",
  //   "totalDeductedMins"
  // );

  // const daysToDeducAirport = createLookup(
  //   airport,
  //   "employeeId",
  //   "totalAbsences"
  // );

  const mandatory = createLookup(contributions, "id", "contributions");
  const excessAirport = createLookup(updatedObj, "id", "excessAirportDuties");

  const firstCase = payrollTypes === "BP" && payItems === "General Payroll";
  const secondCase =
    payrollTypes === "BP" &&
    jobTypeVal !== "Job Order" &&
    payItems === "Addendum Payroll";
  const thirdCase = payrollTypes === "BP" && isAddendumBackPayItem(payItems);
  const fourthCase =
    payrollTypes === "AP" &&
    (payItems === "General Payroll" || payItems === "Newly-Hired");
  const fifthCase =
    payrollTypes === "BP" &&
    jobTypeVal === "Job Order" &&
    payItems === "Salary";
  const sixthCase =
    payrollTypes === "BP" &&
    jobTypeVal === "Job Order" &&
    isBackPayItem(payItems);
  const seventhCase =
    payrollTypes === "IP" &&
    jobTypeVal !== "Job Order" &&
    (payItems === "Initial" || payItems === "Last");
  const eightCase =
    payrollTypes === "IP" &&
    (payItems === "Initial AP" || payItems === "Last AP");
  const ninthCase = payrollTypes === "IP" && payItems === "Rata";
  const tenthCase = payrollTypes === "IP" && payItems === "SalaryDiffBasic";
  const eleventhCase =
    payrollTypes === "IP" &&
    jobTypeVal === "Job Order" &&
    (payItems === "Initial" || payItems === "Last");
  const twelveCase = payrollTypes === "AP" && isBackPayItem(payItems);
  const tirteenthCase =
    payrollTypes === "SP" && payItems !== "20% Monthly Premium";
  const fourteenthCase =
    payrollTypes === "SP" && payItems === "20% Monthly Premium";

  if (
    !firstCase &&
    !secondCase &&
    !thirdCase &&
    !fourthCase &&
    !fifthCase &&
    !sixthCase &&
    !seventhCase &&
    !eightCase &&
    !ninthCase &&
    !tenthCase &&
    !eleventhCase &&
    !twelveCase &&
    !tirteenthCase &&
    !fourteenthCase
  )
    return {};

  const firstCaseLists = {};
  const secondCaseLists = {};
  const thirdCaseLists = {};
  const fourthCaseLists = {};
  const fifthCaseLists = {};
  const sixthCaseLists = {};
  const seventhCaseLists = {};
  const eightCaseLists = {};
  const ninthCaseLists = {};
  const tenthCaseLists = {};
  const eleventhCaseLists = {};
  const twelveCaseLists = {};
  const tirteenthCaseLists = {};
  const fourteenthCaseLists = {};

  for (const [
    index,
    {
      id,
      biometricId,
      salaryGrade,
      nonRegPosition,
      agency,
      payCode,
      position,
      age,
      // monthlyTax,
      // annualTax,
      // netOfMandatory,
      // monthlyPayCode,
      isGraduated,
      // percentTag,
      // isSubmitted,
      twentyFourSeven,
      earnedForThePeriod,
      // oldRate,
      gsisInsuredDays,
      mandatoryDeductions,
      daysInAmonth,
      oldSalaryGrade,
      oldPositionTitle,
      // netEarned,
      earnedBasic,
      daysToBeDeducted,
      halfDaysToBeDeducted,
      minutesToBeDeducted,
      section
    },
  ] of objects.entries()) {

    // console.log("salaryGradeList", salaryGradeList)
    // const salary = 20000;
    const salary = salaryGrade
      ? (Array.isArray(salaryGradeList[id])
          ? salaryGradeList[id]
          : extractSalary(salaryGradeList[id]))
      : extractSalary(nonRegPosition?.montlhyRate);

      console.log("salary", salary);

    const matchContributions = sumallContributions[id] ?? 0;

    const matchCsv = sumCsvData[agency] ?? 0;
    const tax = taxFromCsv[agency] ?? 0;


    // const gsisInsuredDays = calculate(daysInMonth, [
    //   {
    //     type: "subtract",
    //     value: daysTobeDeduc,
    //   },
    // ]);

    // const totalNetMandatory = getTotalNetOfMandatory(
    //   formatted,
    //   netOfMandatory,
    //   "Basic Pay",
    //   "netOfMandatory"
    // );

    // const totalMonthlyTax = getTotalNetOfMandatory(
    //   formatted,
    //   monthlyTax,
    //   "Basic Pay",
    //   "monthlyTax"
    // );
    if (firstCase) {

      const peraAmount = position?.id === "0e2ecac0-6d14-4173-88b6-f04120b1eac2" || position?.id === "40928280-5a48-434c-9aea-4120ff745dd0" ? 1500 : 2000;
      const pera = peraAmount;
      const overpaymentPeraAda = value[index]?.["overpaymentPeraAda"] ?? 0;
      const overpaymentBasic = value[index]?.["overpaymentBasic"] ?? 0;

      const earnedBasic = calculate(salary, [
        { type: "subtract", value: overpaymentBasic },
      ]);
      const earnedPeraAda = calculate(pera, [
        { type: "subtract", value: overpaymentPeraAda },
      ]);

      // const taxLawTotal = calculateTaxLaw(
      //   earnedBasic,
      //   taxes,
      //   sumTaxableAllowance[id],
      //   sumallContributions[id],
      //   0,
      //   totalNetMandatory,
      //   monthIndex,
      //   totalMonthlyTax,
      //   salary
      // );

      // const tax = taxLawTotal?.totalTax ?? 0;
      // const netMandatory = taxLawTotal?.netMandatory ?? 0;
      // const taxDue = taxLawTotal?.taxDue ?? 0;
      const earnedTotal = calculate(earnedBasic, [
        { type: "add", value: earnedPeraAda },
      ]);

      const netAmount = calculate(earnedTotal, [
        {
          type: "subtract",
          value: tax + matchContributions,
        },
      ]);

      const finalNetAmount = calculate(netAmount, [
        { type: "subtract", value: matchCsv },
      ]);

      let net;
      let matchedCsvRow = null;
      if(earnedTotal <= 0){
        net = netAmount
        matchedCsvRow = getMatchedCsvRowByAgency(csv, agency);
      }else{
        net = finalNetAmount;
      }

      firstCaseLists[id] = {
        payrollCode,
        pera,
        overpaymentPeraAda,
        overpaymentBasic,
        earnedBasic,
        earnedPeraAda,
        tax,
        matchedCsvRow,
        netAmount: net,
        // netMandatory,
        // taxDue,
        // daysInMonth,
        // gsisInsuredDays,
      };
    } else if (secondCase) {
      const peraAmount = position?.id === "0e2ecac0-6d14-4173-88b6-f04120b1eac2" || position?.id === "40928280-5a48-434c-9aea-4120ff745dd0" ? 1500 : 2000;
      const pera = peraAmount;

      const processedLogsById = processedLogs[biometricId]?.regular;
      const lookupDataById = lookupData[biometricId];

      const minsToBeDeduc = processedLogsById?.totalLateUTMins;
      const leaveWithoutPaySetById = lookupDataById?.leaveWithoutPay;

      const leaveWithoutPaySize = leaveWithoutPaySetById?.size;

      const daysTobeDeducCount = processedLogsById?.absentCount;
      const halfDaysDeduc = processedLogsById?.halfDayCount;

      const absencesCount = daysTobeDeducCount + leaveWithoutPaySize;

      const gsisLR = mandatory[id]?.gsisLR;
      let phic = mandatory[id]?.phic;
      let pagibig = mandatory[id]?.pagibig;

      const actualAbsenceDates = excludeLeaveFromAbsences(
        processedLogsById?.absentDates,
        leaveWithoutPaySetById,
        id
      );

      const dateOfAbsences = extractDayNumbers(actualAbsenceDates[id]);
      const dateOfHalfDays = extractDayNumbers(processedLogsById?.halfDayDates);
      const dateOfLeaves = extractDayNumbers(leaveWithoutPaySetById);

      const periodCount = getRangeInSelectedDate(datePicked);

      const overpaymentPeraAda = value[index]?.["overpaymentPeraAda"] ?? 0;
      const overpaymentBasic = value[index]?.["overpaymentBasic"] ?? 0;

      // const daysToBeDeducted = calculate(daysInMonth, [
      //   {
      //     type: "subtract",
      //     value: daysTobeDeduc,
      //   },
      // ]);

      const gsisInsuredDays = calculate(periodCount, [
        {
          type: "subtract",
          value: absencesCount,
        },
      ]);

      let gsis = calculate(gsisInsuredDays, [
        { type: "divide", value: daysInMonth },
        { type: "multiply", value: gsisLR },
      ]);

      const mandatoryDeduc = sumObjContributions(contributions);

      const totalMandatory = calculate(mandatoryDeduc[id], [
        { type: "add", value: gsis },
      ]);


      // let assignedHours = 0;
      // if (twentyFourSeven === "9 Hours") {
      //   assignedHours = 9;
      // } else if (twentyFourSeven === "10.5 Hours") {
      //   assignedHours = 10.5;
      // } else {
      //   assignedHours = 12;
      // }


      const firctCalcForTardy = calculate(absencesCount, [
        { type: "multiply", value: salary },
        {
          type: "divide",
          value: 22,
        },
      ]);

      const secondCalcForTardy = calculate(halfDaysDeduc, [
        { type: "multiply", value: salary },
        {
          type: "divide",
          value: 22,
        },
        {
          type: "divide",
          value: 2,
        },
      ]);

      const thirdCalcForTardy = calculate(minsToBeDeduc, [
        { type: "multiply", value: salary },
        { type: "divide", value: 22 },
        { type: "divide", value: 8 },
        { type: "divide", value: 60 },
      ]);

      const leaveAbsenceTardyDeducts = calculate(firctCalcForTardy, [
        { type: "add", value: secondCalcForTardy },
        { type: "add", value: thirdCalcForTardy },
      ]);

      

      const firctCalcForPera = calculate(absencesCount, [
        { type: "multiply", value: pera },
        {
          type: "divide",
          value: 22,
        },
      ]);

      const secondCalcForPera = calculate(halfDaysDeduc, [
        { type: "multiply", value: pera },
        {
          type: "divide",
          value: 22,
        },
        {
          type: "divide",
          value: 2,
        },
      ]);

      const thirdCalcForPera = calculate(minsToBeDeduc, [
        { type: "multiply", value: pera },
        { type: "divide", value: 22 },
        { type: "divide", value: 8 },
        { type: "divide", value: 60 },
      ]);

      const peraDeducts = calculate(firctCalcForPera, [
        { type: "add", value: secondCalcForPera },
        { type: "add", value: thirdCalcForPera },
      ]);

      const earnedBasic = calculate(salary, [
        { type: "subtract", value: leaveAbsenceTardyDeducts },
        { type: "subtract", value: overpaymentBasic },
      ]);

      const earnedPeraAda = calculate(pera, [
        { type: "subtract", value: peraDeducts },
        { type: "subtract", value: overpaymentPeraAda },
      ]);

      // if()

      // const contrib = contributions.filter((obj) => obj.id === id);
      // const fItem = contrib[0];
      // const cont = fItem?.contributions;
      // const excludeKey = "gsisLR";

      // const otherContributionsSum = Object.entries(cont)
      //   .filter(([key]) => key !== excludeKey)
      //   .reduce((sum, [, value]) => sum + parseFloat(value || 0), 0);

      // const totalContribution = parseFloat(
      //   (otherContributionsSum + gsis).toFixed(2)
      // );

      // const taxLawTotal = calculateTaxLaw(
      //   earnedBasic,
      //   taxes,
      //   sumTaxableAllowance[id],
      //   sumallContributions[id],
      //   totalContribution,
      //   totalNetMandatory,
      //   monthIndex,
      //   totalMonthlyTax,
      //   salary
      // );

      // const tax = taxLawTotal?.totalTax ?? 0;
      // const netMandatory = taxLawTotal?.netEarnings ?? 0;
      // const taxDue = taxLawTotal?.taxDue ?? 0;

      let sumOfTotalMandatory = 0;
      let sumOfTotalCsv = 0;
      let sumOfTax = 0;

      if (earnedBasic === 0 && earnedPeraAda === 0) {
        sumOfTotalMandatory = 0;
        sumOfTotalCsv = 0;
        sumOfTax = 0;
        gsis = 0;
      } else {
        sumOfTotalMandatory = totalMandatory;
        sumOfTotalCsv = matchCsv;
        sumOfTax = tax;
      }

      const earnedTotal = calculate(earnedBasic, [
        { type: "add", value: earnedPeraAda },
      ]);

      const netAmount = calculate(earnedTotal, [
        {
          type: "subtract",
          value: sumOfTax + sumOfTotalMandatory,
        },
      ]);

      const finalNetAmount = calculate(netAmount, [
        { type: "subtract", value: sumOfTotalCsv },
      ]);

      let net;
      let matchedCsvRow = null;
      if(earnedTotal <= 0){
        net = netAmount
        matchedCsvRow = getMatchedCsvRowByAgency(csv, agency);
      }else{
        net = finalNetAmount;
      }

      secondCaseLists[id] = {
        payrollCode,
        pera,
        earnedBasic,
        earnedPeraAda,
        overpaymentBasic,
        overpaymentPeraAda,
        phic,
        pagibig,
        gsisLR: gsis,
        // tax,
        // taxDue,
        netAmount: net,
        minsToBeDeduc,
        daysTobeDeduc: absencesCount,
        halfDaysDeduc,
        gsisInsuredDays,
        daysInMonth,
        leaveAbsenceTardyDeducts,
        peraDeducts,
        // netMandatory,
        gsis,
        dateOfAbsences,
        dateOfHalfDays,
        dateOfLeaves,
        matchedCsvRow,
      };
    } else if (thirdCase) {
      const peraAmount = position?.id === "0e2ecac0-6d14-4173-88b6-f04120b1eac2" || position?.id === "40928280-5a48-434c-9aea-4120ff745dd0" ? 1500 : 2000;
      const pera = peraAmount;
      const daysTobeDeduc = absentCountById[id];

      const halfDaystoDeduc = halfDayCountById[id];
      const minutesToDeduc = totalLateUTMinsById[id];
      const daysInMonth = daysInaMonth[id];
      const periodRange = periodCount[id];
      const  gsisLRVal = mandatory[id]?.gsisLR;
      const leaveWithoutPaySetById = createLookup(updatedObj, "id", "leaveWithoutPay");
      const basic = createLookup(updatedObj, "id", "basic");
      const leaveWithoutPaySize = leaveWithoutPaySetById[id]?.size;
      const salaryToUse = basic[id] || salary;

      const totalDaysToDeduct = calculateArray(daysTobeDeduc, [
        { type: "+", value: leaveWithoutPaySize },
      ]);

      const expression = mandatoryFormula["gsisLR"] || "0";

      let valueExpression = calculateAmount(expression, salaryToUse)
      if(valueExpression !== undefined){
        const roundingRules = contributionName.get("gsisLR") || [];

        const roundUpRule = roundingRules?.[1]?.roundUp;
        const roundDownRule = roundingRules?.[0]?.roundDown;

        if (roundUpRule) {
          if (Array.isArray(valueExpression)) {
            valueExpression = valueExpression.map((val) =>
              parseFloat(
                formatCurrency(val.toString()).replace(/,/g, "") || 0
              )
            );
          } 
        } else if (roundDownRule) {
          valueExpression = _calculateAmountRoundDown(expression, salaryToUse);
        } else {
          if (Array.isArray(valueExpression)) {
            valueExpression = valueExpression.map((val) =>
              parseFloat(
                formatCurrency(val.toString()).replace(/,/g, "") || 0
              )
            );
          }
        }
      }

      const absences = absentDatesById[id] || [];
      const halfDayDates = halfDayDatesById[id] || [];
      // const workingDaysSetArray = workingDaysSetArrayById[id] || [];
      const workingDaysCount = workingDaysCountById[id] || 0;

      const datesOfAbsence = formatAbsenceDates(absences);
      const datesOfHalfday = formatAbsenceDates(halfDayDates);


      // const presentWorkDaysByIndex = workingDaysSetArray.map((days, idx) => {
      //   const absSet = absences[idx] || new Set();
      //   const result = [];
      //   for (const date of days) {
      //     if (!absSet.has(date)) {
      //       result.push(date);
      //     }
      //   }
      //   return result;
      // });

      // const lengths = presentWorkDaysByIndex.map(arr =>
      //   Math.min(arr.length, 22)
      // );



      const overpaymentPeraAda = value[index]?.["overpaymentPeraAda"] ??
        overPaymentPera[id] ?? [0];
      const overpaymentBasic = value[index]?.["overpaymentBasic"] ??
        overPaymentBasic[id] ?? [0];
      const tax = value[index]?.["tax"] ?? taxArr[id] ?? [0];
      const pagibig = value[index]?.["pagibig"] ?? pagibigArr[id] ?? [0];
      const phicArr = value[index]?.["phic"] ?? phic[id] ?? [0];

      // let assignedHours = 0;
      // if (twentyFourSeven === "9 Hours") {
      //   assignedHours = 9;
      // } else if (twentyFourSeven === "10.5 Hours") {
      //   assignedHours = 10.5;
      // } else {
      //   assignedHours = 12;
      // }


      let gsisInsuredDays;
      // let basicRateForBackPay;
      // let peraAdaForBackPay;

      console.log( "salaryToUse", salaryToUse);

      const basicRateForBackPay = calculateArray(salaryToUse, [
        { type: "/", value: 22 },
        // { type: "*", value: lengths },
        { type: "*", value: workingDaysCount }, // no need to include absent in deduction (Aug 04,2026)
      ]);
     
      const peraAdaForBackPay = calculateArray(2000, [
        { type: "/", value: 22 },
        // { type: "*", value: lengths },
        { type: "*", value: workingDaysCount }, // no need to include absent in deduction (Aug 04,2026)
      ]);

      if (Array.isArray(daysInMonth) && Array.isArray(daysTobeDeduc)) {
        gsisInsuredDays = periodRange.map((days, index) => {
          const absence = daysTobeDeduc[index] ?? 0;
          const halfDay = halfDaystoDeduc[index] ?? 0;

          const halfDayValue = halfDay * 0;

          return days - absence - halfDayValue;
        });
      }

      let gsis = 0;
      if(age >= 65){
        gsis = 0;
      }else {
        gsis = calculateArray(gsisInsuredDays, [
          { type: "/", value: daysInMonth },
          { type: "*", value: valueExpression },
        ]);
      }


      const firstCalcforTardy = calculateArray(salaryToUse, [
        { type: "/", value: 22 },
        { type: "*", value: totalDaysToDeduct },
      ]);

      const secondCalcforTardy = calculateArray(salaryToUse, [
        { type: "/", value: 22 },
        { type: "/", value: 2 },
        { type: "*", value: halfDaystoDeduc },
      ]);

      const thirdCalcforTardy = calculateArray(salaryToUse, [
        { type: "/", value: 22 },
        { type: "/", value: 8 },
        { type: "/", value: 60 },
        { type: "*", value: minutesToDeduc },
      ]);

      const firstCalcforPera = calculateArray(2000, [
        { type: "/", value: 22 },
        { type: "*", value: totalDaysToDeduct },
      ]);


      const secondCalcforPera = calculateArray(2000, [
        { type: "/", value: 22 },
        { type: "/", value: 2 },
        { type: "*", value: halfDaystoDeduc },
      ]);


      const thirdCalcforPera = calculateArray(2000, [
        { type: "/", value: 22 },
        { type: "/", value: 8 },
        { type: "/", value: 60 },
        { type: "*", value: minutesToDeduc },
      ]);


      const deductionsDueToLeavesAbsencesAndTardinessBasic = calculateArray(
        firstCalcforTardy,
        [
          { type: "+", value: secondCalcforTardy },
          { type: "+", value: thirdCalcforTardy },
        ]
      );

      console.log( "deductionsDueToLeavesAbsencesAndTardinessBasic", deductionsDueToLeavesAbsencesAndTardinessBasic);

    
      

      const deductionPeraAda = calculateArray(firstCalcforPera, [
        { type: "+", value: secondCalcforPera },
        { type: "+", value: thirdCalcforPera },
      ]);


      if (Array.isArray(periodRange)) {
        // basicRateForBackPay = calculateBackPay(salary, periodRange);
        // peraAdaForBackPay = calculateBackPay(2000, periodRange);
      }

      const earnedBasic = calculateArray(
        basicRateForBackPay,
        [
          { type: "-", value: deductionsDueToLeavesAbsencesAndTardinessBasic },
          { type: "-", value: overpaymentBasic },
        ],
        { allowNegative: true }
      );

      const earnedPeraAda = calculateArray(
        peraAdaForBackPay,
        [
          { type: "-", value: deductionPeraAda },
          { type: "-", value: overpaymentPeraAda },
        ],
        { allowNegative: true }
      );

      const groupedBasic = groupAndSumByMonth(earnedBasic, monthNamesArr[id]);
      const groupedPera = groupAndSumByMonth(earnedPeraAda, monthNamesArr[id]);
      const groupedTax = groupAndSumByMonth(tax, monthNamesArr[id]);
      // const groupedGsis = groupAndSumByMonth(gsisLR[id], monthNamesArr[id]);
      // const groupedPhic = groupAndSumByMonth(phic[id], monthNamesArr[id]);
      const groupedPagibig = groupAndSumByMonth(pagibig, monthNamesArr[id]);

      const basicValues = groupedBasic.map((item) => item.value);
      const peraValues = groupedPera.map((item) => item.value);
      const taxValues = groupedTax.map((item) => item.value);
      // const gsisValues = groupedGsis.map((item) => item.value);
      // const phicValues = groupedPhic.map((item) => item.value);
      const pagibigValues = groupedPagibig.map((item) => item.value);
    

      const deductions = calculateArray(taxValues, [
        { type: "+", value: gsis },
        { type: "+", value: phicArr },
        { type: "+", value: pagibigValues },
      ]);


      const earnedTotalValues = calculateArray(basicValues, [
        { type: "+", value: peraValues },
      ]);

      const netAmountValues = calculateArray( earnedTotalValues,[
          { type: "-", value: deductions },
        ],
        { allowNegative: true }
      );

      const finalNetAmountValues = calculateArray(netAmountValues, [
        { type: "-", value: deductionsFromCsv[agency] },
      ]);

      const net = earnedTotalValues.map((value, index) =>
        value <= 0 ? netAmountValues[index] : finalNetAmountValues[index]
      );

      let matchedCsvRow = null;
      let uploadedCsvRow = null;
      const toCheck = finalNetAmountValues.some((value) => value <= 0)

        if(toCheck){
          matchedCsvRow = getMatchedCsvRowByAgency(csv, agency);
        }else{
          matchedCsvRow = "restore";
          uploadedCsvRow = getMatchedCsvRowByAgency(csv, agency);
        }
      

      // const netAmount = groupedBasic.map((item, index) => {
      //   return `${item?.month} - ${netAmountValues[index]}`;
      // });

      thirdCaseLists[id] = {
        payrollCode,
        salary, 
        pera,
        earnedBasic,
        earnedPeraAda,
        overpaymentBasic,
        overpaymentPeraAda,
        tax,
        pagibig,
        phicArr,
        gsis,
        datesOfAbsence,
        datesOfHalfday,
        gsisInsuredDays,
        basicRateForBackPay,
        peraAdaForBackPay,
        deductionsDueToLeavesAbsencesAndTardinessBasic,
        deductionPeraAda,
        matchedCsvRow,
        uploadedCsvRow,
        netAmount: net,
      };
    } else if (fourthCase) {
      const percentage = otherInfo?.percentage;

      const processedLogsById = processedLogs[biometricId]?.regular;
      const lookupDataById = lookupData[biometricId];
      const processedLogsByIdAirport = processedLogs[biometricId]?.airport;
      const lateCountById = processedLogsById?.lateCount;

      const minutesIncurred = processedLogsById?.minutesIncurred ?? [];
      const minsToBeDeduc = processedLogsById?.totalLateUTMins;
      const lateDates = processedLogsById?.lateDates;

      // const minsToBeDeduc = (minutesIncurred ?? []).reduce(
      //   (sum, item) => sum + (Number(item?.totalLateUTMins) || 0),
      //   0
      // );
      const daysTobeDeduc = processedLogsById?.absentCount;
      const leaveWithoutPay = lookupDataById?.leaveWithoutPay;

 

      const totalAbsentCount = (daysTobeDeduc || 0) + leaveWithoutPay?.size;

      const actualAbsenceDates = excludeLeaveFromAbsences( processedLogsById?.absentDates, {}, id);
      const dateOfAbsences = extractDayNumbers(actualAbsenceDates[id], leaveWithoutPay);
      const actualAbsenceDatesAirport = excludeLeaveFromAbsences( processedLogsByIdAirport?.absentDates, {}, id);
      const dateOfAbsencesAirport = extractDayNumbers(actualAbsenceDatesAirport[id]);

      let lateCount = 0;
      let datesOfFlagRaising = [];
      if (section === "20862f43-135d-4c4d-a080-a5f0d97f18c6" || section === "32b20f1c-3040-4778-9807-b5008950fa4f") {
        lateCount = calculate(lateCountById, [
        { type: "multiply", value: 500 },
      ]);
      datesOfFlagRaising = extractDayNumbers(lateDates);
      }else{
        lateCount = 0;
      }

      const minsToBeDeducAirport = processedLogsByIdAirport?.totalLateUTMins;
      const daysToBeDeducAirport = processedLogsByIdAirport?.absentCount;
      const amountForAugmented = extractSalary(natureOfFunction);

      const apRateValue = calculate(percentage, [
        { type: "multiply", value: payCode },
        { type: "divide", value: 100 },
      ]);

      const apRate = value[index]?.["apRate"] ?? apRateValue;

      // let assignedHours = 0;

      // if (twentyFourSeven === "9 Hours") {
      //   assignedHours = 9;
      // } else if (twentyFourSeven === "10.5 Hours") {
      //   assignedHours = 10.5;
      // } else {
      //   assignedHours = 12;
      // }

      // const taxDues = getTotalNetOfMandatory(
      //   formatted,
      //   annualTax,
      //   "Basic Pay",
      //   "annualTax"
      // );

      // const taxDuesGenerated = getTotalNetOfMandatory(
      //   formatted,
      //   annualTax,
      //   "Basic Pay",
      //   "annualTaxation"
      // );

      // const generatedPayCode = getTotalNetOfMandatory(
      //   formatted,
      //   monthlyPayCode,
      //   "Augmentation Pay",
      //   "payCode"
      // );
      // const generatedNetEarned = getTotalNetOfMandatory(
      //   formatted,
      //   netEarned,
      //   "Augmentation Pay",
      //   "payCode"
      // );

      // const amntNetMandatory = getExactNetOfMandatory(
      //   formatted,
      //   netOfMandatory,
      //   "Basic Pay"
      // );

      // const totalMonthlyAPTax = getTotalNetOfMandatory(
      //   formatted,
      //   monthlyTax,
      //   "Augmentation Pay",
      //   "monthlyTax"
      // );

      const daysInAirport = numberOfDutiesinAP?.result?.[id] ?? 0;
      const assignObject = numberOfDutiesinAP?.assignObject?.[id] ?? {};

      console.log("assignObject", assignObject);

      const assignedTwentyFourSeven = parseTwentyFourSevenHours(
        assignObject?.twentyFourSeven
      );


      const apAugmentationRate = daysInAirport > 0 ? amountForAugmented : 0;

      const overpayment = value[index]?.["overpayment"] ?? 0;
      const flagRaising = value[index]?.["flagRaising"] ?? lateCount ?? 0;
      const numberOfDuty =
        value[index]?.["OfDutyForCiaMciaBinocRangeTo1519"] ?? 22;
      const excessAirportDuty = value[index]?.["excessAirportDuties"] ?? 0;
      const numberOfDuty2 =
        value[index]?.["OfDutyForCiaMciaBinocRangeTo15192"] ??
        getDefaultOfDuty(assignObject);

      const proratedApRate = calculate(numberOfDuty, [
        { type: "subtract", value: daysInAirport },
        { type: "multiply", value: apRate },
        { type: "divide", value: numberOfDuty },
      ]);

      const absencesLeaves_1 = calculate(apRate, [
        { type: "divide", value: numberOfDuty },
        { type: "multiply", value: totalAbsentCount },
      ]);

      const lateUtCurrentAss = Number(minutesIncurred.reduce
        ((sum, item) => sum + calculateTotalFromMins(item, apRate, numberOfDuty),0).toFixed(2));

      // const lateUtCurrentAss = calculate(apRate, [
      //   { type: "divide", value: numberOfDuty },
      //   { type: "divide", value: 9 },
      //   { type: "divide", value: 60 },
      //   { type: "multiply", value: minsToBeDeduc },
      // ]);

      const earnedCurrAss = calculate(proratedApRate, [
        { type: "subtract", value: absencesLeaves_1 },
        { type: "subtract", value: lateUtCurrentAss },
      ]);

      const airportAugAmt = calculate(apAugmentationRate, [
        { type: "divide", value: 22 },
        { type: "multiply", value: daysInAirport },
      ]);
      const absencesLeaves_2 = calculate(apAugmentationRate, [
        { type: "divide", value: numberOfDuty2 },
        { type: "multiply", value: daysToBeDeducAirport },
      ]);

      const lateUtAirportAss = calculate(27000, [
        { type: "divide", value: numberOfDuty2 },
        { type: "divide", value: assignedTwentyFourSeven },
        { type: "divide", value: 60 },
        { type: "multiply", value: minsToBeDeducAirport },
      ]);

      const airportDutyEarned = calculate(airportAugAmt, [
        { type: "subtract", value: absencesLeaves_2 },
        { type: "subtract", value: lateUtAirportAss },
      ]);

      const totalEarned = calculate(earnedCurrAss, [
        { type: "add", value: airportDutyEarned },
        { type: "add", value: excessAirportDuty },
      ]);

      const netEarn = calculate(totalEarned, [
        { type: "subtract", value: overpayment },
        { type: "subtract", value: flagRaising },
      ]);

      // const getGeneratedBasic = getTotalNetOfMandatory(
      //   formatted,
      //   netEarned,
      //   "Basic Pay",
      //   "netEarned"
      // );

      // const tax = calculateApTax(
      //   netEarn,
      //   monthIndex,
      //   apRate,
      //   salary,
      //   taxes,
      //   sumTaxableAllowance[id],
      //   sumallContributions[id],
      //   totalNetMandatory,
      //   amntNetMandatory,
      //   taxDuesGenerated,
      //   generatedNetEarned,
      //   totalMonthlyAPTax,
      //   getGeneratedBasic
      // );

      // const apTax = tax?.monthlyApTax;
      // const taxDue = tax?.remainingTaxDue;

      const netAmount = calculate(netEarn, [
        { type: "subtract", value: tax  },
      ]);

      const finalNetAmount = calculate(netAmount, [
        { type: "subtract", value: matchCsv },
      ]);

      let net;
      let matchedCsvRow = null;
      if(netEarn <= 0){
        net = netAmount
        matchedCsvRow = getMatchedCsvRowByAgency(csv, agency);
      }else{
        net = finalNetAmount;
      }

      fourthCaseLists[id] = {
        payrollCode,
        apRate,
        proratedApRate,
        daysInAirport,
        minsToBeDeduc,
        daysTobeDeduc,
        minsToBeDeducAirport,
        daysToBeDeducAirport,
        lateUtCurrentAss,
        absencesLeaves_1,
        dateOfAbsences,
        datesOfFlagRaising,
        dateOfAbsencesAirport,
        totalAbsentCount,
        assignObject,
        matchedCsvRow,
        // taxDue,
        // tax: apTax,
        overpayment,
        flagRaising,
        excessAirportDuty,
        numberOfDuty,
        numberOfDuty2,
        earnedCurrAss,
        apAugmentationRate,
        absencesLeaves_2,
        lateUtAirportAss,
        airportAugAmt,
        airportDutyEarned,
        totalEarned,
        netEarned: netEarn,
        netAmount: net,
      };
    } else if (fifthCase) {
      const processedLogsById = processedLogs[biometricId]?.regular;
      const lookupDataById = lookupData[biometricId];

      const minsToBeDeduc = processedLogsById?.totalLateUTMins;
      const daysTobeDeduc = processedLogsById?.absentCount;
      const halfDaysDeduc = processedLogsById?.halfDayCount;
      const labelCountById = processedLogsById?.lateCount;
      const leaveWithoutPaySetById = lookupDataById?.leaveWithoutPay;
      const minutesIncurred = processedLogsById?.minutesIncurred ?? [];
      const lateDates = processedLogsById?.lateDates;

      // const assignedTwentyFourSeven = parseTwentyFourSevenHours(
      //   assignObject?.twentyFourSeven
      // );

      const isGrad = isGraduated === "YES";
      // const isAnnexSubmitted = isSubmitted === "YES";
      const sumTaxesFromCsv = taxPercentFromCsv[agency];
      const sumDeductionsFromCsv = deductionsFromCsv[agency];

      let lateCount = 0;
      let datesOfFlagRaising = "";

      if (section === "20862f43-135d-4c4d-a080-a5f0d97f18c6" || section === "32b20f1c-3040-4778-9807-b5008950fa4f") {
        lateCount = calculate(labelCountById, [
        { type: "multiply", value: 500 },
      ]);
      datesOfFlagRaising = extractDayNumbers(lateDates);
      }else{
        lateCount = 0;
        datesOfFlagRaising = "";
      }

      const overpayment = value[index]?.["overpayment"] ?? 0;
      const flagRaising = value[index]?.["flagRaising"] ?? lateCount ?? 0;

      const actualAbsenceDates = excludeLeaveFromAbsences(
        processedLogsById?.absentDates,
        leaveWithoutPaySetById,
        id
      );
      
      const dateOfAbsences = extractDayNumbers(actualAbsenceDates[id]);

      let threePercent = 0;
      let twoPercent = 0;
      let fivePercent = 0;
      let tenPercent = 0;
      // let assignedHours = 0;

      // if (twentyFourSeven === "9 Hours") {
      //   assignedHours = 9;
      // } else if (twentyFourSeven === "10.5 Hours") {
      //   assignedHours = 10.5;
      // } else {
      //   assignedHours = 12;
      // }

      const numberOfDays = value[index]?.["noOfDays"] ?? 22;
      const absencesDays = calculate(salary, [
        { type: "multiply", value: daysTobeDeduc },
        { type: "divide", value: numberOfDays },
      ]);

      // const absencesMins = calculate(salary, [
      //   { type: "divide", value: numberOfDays },
      //   { type: "divide", value: 8 },
      //   { type: "divide", value: 60 },
      //   { type: "multiply", value: minsToBeDeduc },
      // ]);

      const absencesMins = Number(minutesIncurred.reduce
        ((sum, item) => sum + calculateTotalFromMins(item, salary, numberOfDays),0).toFixed(2));


      let earnedFoPeriod = calculate(salary, [
        { type: "subtract", value: absencesDays },
        { type: "subtract", value: absencesMins },
        { type: "subtract", value: overpayment },
        { type: "subtract", value: flagRaising },
      ]);

      if(earnedFoPeriod < 0){
        earnedFoPeriod = 0;
      }

      // const totalEarnedForPeriod = getTotalNetOfMandatory(
      //   formatted,
      //   earnedForThePeriod,
      //   "Basic Pay",
      //   "netOfMandatory"
      // );

      // const joTax = calculateJOTax(
      //   salary,
      //   monthIndex,
      //   gratuityAllowance[id],
      //   totalEarnedForPeriod
      // );

      if (isGrad) {
        threePercent = calculate(earnedFoPeriod, [
          { type: "multiply", value: 0.03 },
        ]);
      }

      // if (percentTag === "2%" && isAnnexSubmitted) {
      //   twoPercent = calculate(joTax, [
      //     { type: "divide", value: monthIndex },
      //     { type: "multiply", value: 0.02 },
      //   ]);
      // } else if (percentTag === "5%" && isAnnexSubmitted) {
      //   fivePercent = calculate(joTax, [
      //     { type: "divide", value: monthIndex },
      //     { type: "multiply", value: 0.05 },
      //   ]);
      // } else {
      //   tenPercent = calculate(joTax, [
      //     { type: "divide", value: monthIndex },
      //     { type: "multiply", value: 0.1 },
      //   ]);
      // }

      const totalTax = calculate(threePercent, [
        { type: "add", value: sumTaxesFromCsv },
        // { type: "add", value: twoPercent },
        // { type: "add", value: fivePercent },
        // { type: "add", value: tenPercent },
      ]);

      const netPay = calculate(earnedFoPeriod, [
        { type: "subtract", value: totalTax },
      ]);

      const finalNetPay = calculate(netPay, [
        { type: "subtract", value: sumDeductionsFromCsv },
      ]);

      let net;
      let matchedCsvRow = null;
      if(earnedFoPeriod <= 0){
        net = netPay
        matchedCsvRow = getMatchedCsvRowByAgency(csv, agency);
      }else{
        net = finalNetPay;
      }

      fifthCaseLists[id] = {
        minsToBeDeduc,
        daysTobeDeduc,
        halfDaysDeduc,
        dateOfAbsences,
        datesOfFlagRaising,
        matchedCsvRow,
        absencesDays,
        absencesMins,
        overpayment,
        flagRaising,
        earnedFoPeriod,
        threePercent,
        salary,
        twoPercent,
        fivePercent,
        tenPercent,
        totalTax,
        netPay: net,
      };
    } else if (sixthCase) {

      // const periodRange = periodCount[id];

      const absentCount =  daysToBeDeduc[id];
      const numberofDays = numOfDays[id];
      const basic = basicArr[id];
      const overPayment = ovrPayment[id];
      const threePercnt = three[id];
      const twoPercnt = two[id];
      const fivePercnt = five[id];
      const tenPercnt = ten[id];
      const actuaMinsIncurredRaw = minutesIncurredById[id];
      const late = lateCountById[id];
      const dateOfFlagRaising = dateOfFlagRaisingById[id];

      const datesOfAbsence = formatAbsenceDates(absentDatesById[id]);

      const year = extractYearMonth(monthNamesArr[id], "year");
      const month = extractYearMonth(monthNamesArr[id], "month");

      let flag = [];
      let datesOfFlagRaising = [];
      if (section === "20862f43-135d-4c4d-a080-a5f0d97f18c6" || section === "32b20f1c-3040-4778-9807-b5008950fa4f") {
        flag = calculateArray(late, [
        { type: "*", value: 500 },
      ]);
      datesOfFlagRaising = formatAbsenceDates(dateOfFlagRaising);
    }else{
      flag = [0];
    }

      const hasFlagLength = flag.length > 0 ? flag : ['']

      const overpayment = value[index]?.["overpayment"] ?? overPayment ?? [0];
      const flagRaising = value[index]?.["flagRaising"] ?? hasFlagLength;

      const noOfDays = value[index]?.["noOfDays"] ?? numberofDays ?? [22];
      const threePercent = value[index]?.["3"] ?? threePercnt ?? [0];
      const twoPercent = value[index]?.["2"] ?? twoPercnt ?? [0];
      const fivePercent = value[index]?.["5"] ?? fivePercnt ?? [0];
      const tenPercent = value[index]?.["10"] ?? tenPercnt ?? [0];
      const basicRate = value[index]?.["basic"] ?? basic ?? [salary];


      const actuaMinsIncurred = Array.isArray(actuaMinsIncurredRaw) && actuaMinsIncurredRaw.length > 0
      ? actuaMinsIncurredRaw.map((dateRangeArray, rangeIndex) => {
        const currentApRate = Array.isArray(basicRate) ? basicRate[rangeIndex] : salary;
        const currentNumberOfDuty = Array.isArray(noOfDays) ? noOfDays[rangeIndex] : noOfDays;

          const accumulated = dateRangeArray.reduce((sum, minsIncurredItem) => {
            const calculated = calculateTotalFromMins(minsIncurredItem, currentApRate, currentNumberOfDuty);
            return sum + calculated;
          }, 0);
          
          return accumulated;
        })
      : [];


      const fixed =
      Array.isArray(actuaMinsIncurred) && actuaMinsIncurred.length > 0
        ? actuaMinsIncurred.map((v) => Number(parseFloat(v).toFixed(2)))
        : actuaMinsIncurred;

      let assignedHours = [];

      noOfDays.forEach(() => {
        if (twentyFourSeven === "9 Hours") {
          assignedHours.push(9);
        } else if (twentyFourSeven === "10.5 Hours") {
          assignedHours.push(10.5);
        } else {
          assignedHours.push(12);
        }
      });

      // let basicRateForBackPay;
      // if (Array.isArray(periodRange)) {
      //   basicRateForBackPay = calculateBackPay(salary, periodRange);
      // }

      const divisor = calculateArray(noOfDays, [
        { type: "-", value: absentCount },
      ]);

      const basicRateForBackPay = calculateArray(basicRate, [
        { type: "/", value: noOfDays },
        { type: "*", value: divisor },
      ]);

      const absencesDays = calculateArray(basicRate, [
        { type: "/", value: noOfDays },
        { type: "*", value: absentCount },
      ]);

      // const absencesMins = calculateArray(salary, [
      //   { type: "/", value: noOfDays },
      //   { type: "/", value: assignedHours },
      //   { type: "/", value: 60 },
      //   { type: "*", value: minsToDeduc },
      // ]);


      const earnedForThePeriod = calculateArray(basicRateForBackPay, [
        { type: "-", value: absencesDays },
        { type: "-", value: fixed },
        { type: "-", value: overpayment },
        { type: "-", value: flagRaising },
      ]).map((n) => Math.max(0, Number(n) || 0));

      const totalTax = calculateArray(threePercent, [
        { type: "+", value: twoPercent },
        { type: "+", value: fivePercent },
        { type: "+", value: tenPercent },
        { type: "+", value: taxPercentFromCsv[agency] },
      ]);

      const groupedEarnedForPrd = groupAndSumByMonth(
        earnedForThePeriod,
        monthNamesArr[id]
      );
      const groupedTotalTax = groupAndSumByMonth(totalTax, monthNamesArr[id]);

      const earnedPeriodValues = groupedEarnedForPrd.map((item) => item.value);
      const totalTaxValues = groupedTotalTax.map((item) => item.value);

      const netPayValues = calculateArray(earnedPeriodValues, [
        { type: "-", value: totalTaxValues }
      ]);

      const finalNetAmountValues = calculateArray(netPayValues, [
        { type: "-", value: deductionsFromCsv[agency] },
      ]);

      const net = earnedPeriodValues.map((value, index) =>
        value <= 0 ? netPayValues[index] : finalNetAmountValues[index]
      );

        let matchedCsvRow = null;
        let uploadedCsvRow = null;
        const toCheck = finalNetAmountValues.some((value) => value <= 0)
  
          if(toCheck){
            matchedCsvRow = getMatchedCsvRowByAgency(csv, agency);
          }else{
            matchedCsvRow = "restore";
            uploadedCsvRow = getMatchedCsvRowByAgency(csv, agency);
          }


      // const netAmount = groupedEarnedForPrd.map((item, index) => {
      //   return `${item?.month} - ${netPayValues[index]}`;
      // });

      sixthCaseLists[id] = {
        salary,
        basicRate,
        year,
        month,
        datesOfAbsence,
        datesOfFlagRaising,
        overpayment,
        flagRaising,
        basicRateForBackPay,
        absencesDays,
        absencesMins: fixed,
        noOfDays,
        earnedForThePeriod,
        threePercent,
        twoPercent,
        fivePercent,
        tenPercent,
        totalTax,
        matchedCsvRow,
        uploadedCsvRow,
        netAmount: net,
      };
    } else if (seventhCase) {

      const peraAmount = position?.id === "0e2ecac0-6d14-4173-88b6-f04120b1eac2" || position?.id === "40928280-5a48-434c-9aea-4120ff745dd0" ? 1500 : 2000;
      const pera = peraAmount;
      const holWkendsOff = 0;

      console.log("salary", salary);


      const lookupDataById = lookupData[biometricId];
      const processedLogsById = processedLogs[biometricId]?.regular;

      const minsToBeDeduc = processedLogsById?.totalLateUTMins;
      const daysTobeDeduc = processedLogsById?.absentCount;
      const halfdaysTobeDeduc =  processedLogsById?.halfDayCount;
      const actualWorkingDays = lookupDataById?.workingDaysSetArray;
      const suspensionSet = lookupDataById?.suspensions;
      const holidaySet = lookupDataById?.holidays;
      const leaveWithoutPaySetSize = lookupDataById?.leaveWithoutPay.size;
      const minutesIncurred = processedLogsById?.minutesIncurred ?? [];

      console.log("actualWorkingDays", actualWorkingDays);

      const pagibig = value[index]?.["pagibig"] ?? 0;
      // const phic = value[index]?.["phic"] ?? 0;
      const tax = value[index]?.["tax"] ?? 0;

      const periodCount = getRangeInSelectedDate(datePicked);
      const suspensionCount = suspensionSet?.size ?? 0;
      const holidayCount = holidaySet?.size ?? 0;
      const halfDaysCount = (halfdaysTobeDeduc ?? 0) * 0.5;

      const isTwelveOrNine = ["12", "9"].some((prefix) =>
        twentyFourSeven?.startsWith(prefix)
      );

      const suspensionDeduction = isTwelveOrNine ? 0 : suspensionCount;
      const holidayDeduction = isTwelveOrNine ? 0 : holidayCount;

      // let assignedHours = 0;
      // if (twentyFourSeven === "9 Hours") {
      //   assignedHours = 9;
      // } else if (twentyFourSeven === "10.5 Hours") {
      //   assignedHours = 10.5;
      // } else {
      //   assignedHours = 12;
      // }


      // const params = {
      //   id,
      //   actualWorkDays,
      //   absentDateByEmployee,
      //   halfDateByEmployee,
      // };
    
      // const inServiceCount = getInServiceCount(params);

      // const inService = Math.min(
      //   calculate(actualWorkingDays, [
      //     { type: "subtract", value: daysTobeDeduc },
      //   ]),
      //   22
      // );

      // const inService = inServiceCount;

      // const inServiceMax = inService > 22 ? 22 : inService;
      const workingDaysLength = actualWorkingDays?.[0]?.size ?? 0;
      console.log("workingDaysLength", workingDaysLength);

      console.log("daysTobeDeduc", daysTobeDeduc);

      const newInService = Math.max(
        0,
        Math.min(
          22,
          workingDaysLength
            - daysTobeDeduc
            - leaveWithoutPaySetSize
            - halfDaysCount
            - suspensionDeduction
            - holidayDeduction
        )
      );



      const insuredDays = calculate(periodCount, [
        { type: "subtract", value: daysTobeDeduc },
        { type: "subtract", value: leaveWithoutPaySetSize },
      ]);

      let gsis = 0;
      
      if(age >= 66){
        gsis = 0;
      }else {
       gsis = calculate(salary, [
        { type: "multiply", value: insuredDays },
        { type: "divide", value: daysInMonth },
        { type: "multiply", value: 0.09 },
      ]);
    }

      let mandatoryDeduc = sumObjContributions(contributions, "pagibig");

      // if (payItems === "Last") {
      //   mandatoryDeduc[id] -= 200;
      // }
      let totalMandatory = 0;
      if(payItems === "Initial"){
        const deductions = sumObjContributions(contributions, "gsisLR");
       totalMandatory = calculate(deductions[id], [
        { type: "add", value: gsis },
      ]);
    }else{
      totalMandatory = calculate(mandatoryDeduc[id], [
        { type: "add", value: gsis },
      ]);
    }

      const proratedRate = calculate(salary, [
        { type: "multiply", value: newInService },
        { type: "divide", value: 22 },
      ]);

      const proratedPera = calculate(2000, [
        { type: "multiply", value: newInService },
        { type: "divide", value: 22 },
      ]);

      const perDay = calculate(salary, [{ type: "divide", value: 22 }]);
      const perHalfDay = calculate(salary, [
        { type: "divide", value: 22 },
        { type: "divide", value: 2 },
      ]);

      const perMinute = calculate(salary, [
        { type: "divide", value: 22 },
        { type: "divide", value: 8 },
        { type: "divide", value: 60 },
      ]);

      const perDay2 = calculate(2000, [{ type: "divide", value: 22 }]);

      const perMinute2 = calculate(2000, [
        { type: "divide", value: 22 },
        { type: "divide", value: 8 },
        { type: "divide", value: 60 },
      ]);

      const days2 = calculate(daysTobeDeduc, [
        { type: "multiply", value: perDay },
      ]);

      const halfDays2 = calculate(halfdaysTobeDeduc, [
        { type: "multiply", value: perHalfDay },
      ]);


      // const mins2 = calculate(salary, [
      //   // { type: "multiply", value: perMinute },
      //   { type: "divide", value: 22 },
      //   { type: "divide", value: 8 },
      //   { type: "divide", value: 60 },
      //   { type: "multiply", value: minsToBeDeduc },
      // ]);

      const mins2 = Number(minutesIncurred.reduce
        ((sum, item) => sum + calculateTotalFromMins(item, salary, 22, 8),0).toFixed(2));

      const basic = calculate(days2, [
        { type: "add", value: halfDays2 },
        { type: "add", value: mins2 },
      ]);

      const days3 = calculate(daysTobeDeduc, [
        { type: "multiply", value: perDay2 },
      ]);
      // const mins3 = calculate(2000, [
      //   // { type: "multiply", value: perMinute2 },
      //   { type: "divide", value: 22 },
      //   { type: "divide", value: 8 },
      //   { type: "divide", value: 60 },
      //   { type: "multiply", value: minsToBeDeduc },
      // ]);

      const mins3 = Number(minutesIncurred.reduce
        ((sum, item) => sum + calculateTotalFromMins(item, 2000, 22, 8),0).toFixed(2));

      const pera2 = calculate(days3, [{ type: "add", value: mins3 }]);

      const basicEarned = calculate(proratedRate, [
        { type: "subtract", value: mins2 },
      ]);
      const peraEarned = calculate(proratedPera, [
        { type: "subtract", value: mins3 },
      ]);
      const total = calculate(basicEarned, [
        { type: "add", value: peraEarned },
      ]);

      const netPay = calculate(total, [
        { type: "subtract", value: tax },
        { type: "subtract", value: totalMandatory },
        { type: "subtract", value: pagibig },
        // { type: "subtract", value: phic },
      ]);

      seventhCaseLists[id] = {
        pera,
        inService: newInService,
        daysInMonth,
        holWkendsOff,
        proratedRate,
        proratedPera,
        perDay,
        perMinute,
        perDay2,
        perMinute2,
        daysTobeDeduc,
        halfdaysTobeDeduc,
        minsToBeDeduc,
        insuredDays,
        days2,
        halfDays2,
        mins2,
        basic,
        days3,
        mins3,
        pera2,
        basicEarned,
        peraEarned,
        total,
        tax,
        pagibig,
        // phic,
        gsis,
        netPay,
      };
    } else if (eightCase) {
      const minsToBeDeduc = minsToBeDeducted[id];
      // const actualWorkingDays = workingDays[id];
      // const daysTobeDeduc = daysToDedudAdd[id];
      const overPayment = ovrPayment[id];
      // const flagraising = flgRaising[id];
      const totalAbsences = daysToBeDeduc[id];
      const totalLatesUt = minsToBeDeducted[id];
      const workingDaysCount = workingDaysCountById[id];
      const leaveWithoutPay = createLookup(updatedObj, "id", "leaveWithoutPay");
      const leaveWithoutPaySetSize = leaveWithoutPay[id]?.size;
      const dateOfFlagRaising = dateOfFlagRaisingById[id];

      const isTwelveOrNine = ["12", "9"].some((prefix) =>
        twentyFourSeven?.startsWith(prefix)
      );

      const holidayCount = holidaysById[id]?.size ?? 0;
      const suspensionCount = suspensionsById[id]?.size ?? 0;


      const late = lateCountById[id]; 

      let flag = [];
      let datesOfFlagRaising = [];
      if (section === "20862f43-135d-4c4d-a080-a5f0d97f18c6" || section === "32b20f1c-3040-4778-9807-b5008950fa4f") {
        flag = calculateArray(late, [
        { type: "*", value: 500 },
      ]);
      datesOfFlagRaising = formatAbsenceDates(dateOfFlagRaising);
      }else{
        flag = [0];
      }

      const hasFlagLength = flag.length > 0 ? flag : ['']

      // const allMinsIncurred = minsIncurred[id];
      const numberOfDuty = value[index]?.["OfDutyForCiaMciaBinocRangeTo1519"] ??
      dutyForCiaMciaBinoc[id] ?? [22];
      const actuaMinsIncurredRaw = minutesIncurredById[id];

      const apRate = value[index]?.["apRate"] ?? apRateAmount[id] ?? [payCode];

      // Compute actuaMinsIncurred using calculateTotalFromMins and accumulate the results
      const actuaMinsIncurred = Array.isArray(actuaMinsIncurredRaw) && actuaMinsIncurredRaw.length > 0
        ? actuaMinsIncurredRaw.map((dateRangeArray, rangeIndex) => {
            const currentApRate = Array.isArray(apRate) ? apRate[rangeIndex] : apRate;
            const currentNumberOfDuty = Array.isArray(numberOfDuty) ? numberOfDuty[rangeIndex] : numberOfDuty;
            
            // Calculate total for each item and accumulate (sum) the results
            const accumulated = dateRangeArray.reduce((sum, minsIncurredItem) => {
              const calculated = calculateTotalFromMins(minsIncurredItem, currentApRate, currentNumberOfDuty);
              return sum + calculated;
            }, 0);
            
            return accumulated;
          })
        : [];


      const fixed =
        Array.isArray(actuaMinsIncurred) && actuaMinsIncurred.length > 0
          ? actuaMinsIncurred.map((v) => Number(parseFloat(v).toFixed(2)))
          : actuaMinsIncurred;

      const overpayment = value[index]?.["overpayment"] ?? overPayment ?? [0];
      const flagRaising = value[index]?.["flagRaising"] ?? hasFlagLength;
      const tax = value[index]?.["tax"] ?? taxArr[id] ?? [0];

      // const earnedDays = getActualAttendanceDates(workingDates, totalAbsences);
      const actualDaysEarned = calculateArray(workingDaysCount, [
        { type: "-", value: totalAbsences },
        { type: "-", value: leaveWithoutPaySetSize },
        ...(!isTwelveOrNine
          ? [
              { type: "-", value: holidayCount },
              { type: "-", value: suspensionCount },
            ]
          : []),
      ]);


      const newDaysEarned = actualDaysEarned.map(value => 
        Math.max(0, Math.min(22, value))
      );


      // const inService = calculate(actualWorkingDays, [
      //   { type: "subtract", value: daysTobeDeduc },
      // ]);

      // const latesUtDeduction = calculateArray(apRate, [
      //   { type: "/", value: 22 },
      //   { type: "/", value: 8 },
      //   { type: "/", value: 60 },
      //   { type: "*", value: totalLatesUt },
      // ]);

      const earnedForThePeriod = calculateArray(apRate, [
        { type: "/", value: numberOfDuty },
        { type: "*", value: newDaysEarned },
        { type: "-", value: fixed },
        { type: "-", value: overpayment },
        { type: "-", value: flagRaising },
      ]);

      const groupedEarned = groupAndSumByMonth(
        earnedForThePeriod,
        monthNamesArr[id]
      );

      const groupTotalTax = groupAndSumByMonth(tax, monthNamesArr[id]);
      const earnedPeriodValues = groupedEarned.map((item) => item.value);
      const taxValues = groupTotalTax.map((item) => item.value);

      const netAmount = calculateArray(earnedPeriodValues, [
        { type: "-", value: tax },
      ]);

      // const netAmount = groupedEarned.map((item, index) => {
      //   return `${item?.month} - ${netPayValues[index]}`;
      // });


      eightCaseLists[id] = {
        apRate,
        payCode,
        minsToBeDeduc,
        latesUtDeduction: fixed,
        totalLatesUt,
        datesOfFlagRaising,
        daysEarned: newDaysEarned,
        overpayment,
        flagRaising,
        numberOfDuty,
        earnedForThePeriod,
        tax,
        netAmount,
      };
    } else if (ninthCase) {
      const lookupDataById = lookupData[biometricId];
      const processedLogsById = processedLogs[biometricId]?.regular;
      const workingDaysCount = lookupDataById?.workingDaysCount;
      const absentCount = processedLogsById?.absentCount;
      const rata = rataAllowance[id];

      const inService = calculate(workingDaysCount, [
        { type: "subtract", value: absentCount },
      ]);

      let actualRataForAMonth = 0;

      if (inService >= 1 && inService <= 5) {
        actualRataForAMonth = 25;
      } else if (inService >= 6 && inService <= 11) {
        actualRataForAMonth = 50;
      } else if (inService >= 12 && inService <= 16) {
        actualRataForAMonth = 75;
      } else if (inService >= 17) {
        actualRataForAMonth = 100;
      }

      const concatPercent = `${actualRataForAMonth}%`;
      const percentageDecimal = actualRataForAMonth / 100;

      const netAmount = calculate(rata, [
        { type: "multiply", value: percentageDecimal },
      ]);

      ninthCaseLists[id] = {
        rata,
        inService,
        concatPercent,
        netAmount,
      };
    } else if (tenthCase) {
      const myDiff = value[index]?.["myDiff"] ?? 0;
      const yeDiff = value[index]?.["yeDiff"] ?? 0;
      const tax = value[index]?.["tax"] ?? 0;

      const params = {
        salary,
        daysToBeDeducted,
        halfDaysToBeDeducted,
        minutesToBeDeducted,
      };

      const itemForOldRate = _getItemOldRate(earnedBasic, datePicked);
      const itemForNewRate = _getItemNewRate(params);

      console.log("itemForNewRate", itemForNewRate);

      console.log("itemForOldRate", itemForOldRate);
      const itemForMandatory = _getItemOldRate(mandatoryDeductions, datePicked);

      const gsisOldRate = getGsisOldRate(itemForMandatory, "gsisLR");

      const gsisNewRate = getGsisNewRate(
        gsisInsuredDays,
        daysInAmonth,
        salary,
        mandatoryFormula,
        mandatoryDeductions,
        "gsisLR"
      );

      const phicOldRate = getGsisOldRate(itemForMandatory, "phic");

      const phicNewRate = getGsisNewRate(
        gsisInsuredDays,
        daysInAmonth,
        salary,
        mandatoryFormula,
        mandatoryDeductions,
        "phic"
      );
      console.log("phicNewRate", phicNewRate);

      console.log("salary", salary);

      const salaryDifferential = _getSalaryDiff(itemForOldRate, itemForNewRate);

      console.log("salaryDifferential", salaryDifferential);

      const gsis = calculate(gsisNewRate, [
        { type: "subtract", value: gsisOldRate },
      ]);
      const phic = calculate(phicNewRate, [
        { type: "subtract", value: phicOldRate },
      ]);

      // const tax = 0;
      const netPay = calculate(salaryDifferential, [
        { type: "subtract", value: gsis },
        { type: "subtract", value: phic },
        { type: "subtract", value: tax },
        { type: "add", value: myDiff },
        { type: "add", value: yeDiff },
      ]);

      tenthCaseLists[id] = {
        salaryDifferential,
        gsis,
        phic,
        tax,
        myDiff,
        yeDiff,
        netPay,
        oldPositionTitle,
        oldSalaryGrade,
      };
    } else if (eleventhCase) {
      const processedLogsById = processedLogs[biometricId]?.regular;
      const lookupDataById = lookupData[biometricId];
      const daysTobeDeduc = processedLogsById?.absentCount;
      const suspensionSet = processedLogsById?.suspensions;
      const holidaySet = processedLogsById?.holidays;

      const isTwelveOrNine = ["12", "9"].some((prefix) =>
        twentyFourSeven?.startsWith(prefix)
      );

      console.log("value", value);

      // const actualWorkingDays = workingDays[id];
      const isGrad = isGraduated === "YES";
      // const isAnnexSubmitted = isSubmitted === "YES";
      const twoPercent = value[index]?.["2"] ?? 0;
      const gratuityPay = value[index]?.["gratuityPay"] ?? 0;
      // const allMinsIncurred = minsIncurred[id];
      // const val = minsIncurredLists[id];
      // const notArrMinsIncurred = parseFloat((val?.toFixed(2)) || 0);

      const suspensionCount = suspensionSet?.size ?? 0;
      const holidayCount = holidaySet?.size ?? 0;

      let numberOfDuty;
      let threePercent = 0;
      let inService = 0;
      let proratedRate = 0;
      let minsToBeDeduc;
      let absMins = 0;
      let earned = 0;
      let netAmount = 0;
      let basicSalary = 0;
      // = calculate(actualWorkingDays, [
      //   { type: "subtract", value: daysTobeDeduc },
      // ]);


      // const res = actualWorkDays[id].length - deduc;


      // let count = 0;

      // if (twentyFourSeven === "10.5 Hours") {
      //   count = 10.5;
      // } else if (twentyFourSeven === "9 Hours") {
      //   count = 9;
      // } else {
      //   count = 12;
      // }

      let twentyPercent;


      if (payItems === "Initial") {
        // const params = {
        //   id,
        //   actualWorkDays,
        //   absentDateByEmployee: absences,
        // };

        const absentDates = processedLogsById?.absentDates;
        const workingDaysCount = lookupDataById?.workingDaysCount;
        const minutesIncurred = processedLogsById?.minutesIncurred;
        const totalLateUTMins = processedLogsById?.totalLateUTMins;
        
        const absencesLength = absentDates?.size || 0;

        const actualDaysEarned = calculate(workingDaysCount, [
          { type: "subtract", value: absencesLength },
          ...(!isTwelveOrNine
            ? [
                { type: "subtract", value: suspensionCount },
                { type: "subtract", value: holidayCount }
              ]
            : []),
        ]);

        const newDaysEarned = Math.max(0, Math.min(22, actualDaysEarned));

        // const inServiceCount = getInServiceCount(params);
        inService = newDaysEarned;
        basicSalary = salary;


        numberOfDuty = value[index]?.["OfDutyForCiaMciaBinocRangeTo1519"] ?? 22;
        const actualMinsIncurred = Array.isArray(minutesIncurred) && minutesIncurred.length > 0
        ? minutesIncurred.map((dateRangeArray) => {
            const result = calculateTotalFromMins(
              dateRangeArray,
              salary,
              numberOfDuty
            );

            return result;
          })
        : [];

        const totalActualMinsIncurred = 
        Number(
          actualMinsIncurred.reduce((sum, val) => sum + val, 0).toFixed(2)
        );


        proratedRate = calculate(salary, [
          { type: "multiply", value: inService },
          { type: "divide", value: numberOfDuty },
        ]);
        minsToBeDeduc = totalLateUTMins;
        absMins = totalActualMinsIncurred;
        earned = calculate(salary, [
          { type: "divide", value: 22 },
          { type: "multiply", value: inService },
          { type: "subtract", value: absMins },
        ]);

        const twentyPercentValue = calculate(earned, [
          { type: "multiply", value: 0.2 },
        ]);

        twentyPercent = value[index]?.["20"] ?? twentyPercentValue ?? 0;
      } else {
        const workingDaysCount = workingDaysCountById[id];
        const totalAbsences = daysToBeDeduc[id];
        const holidayCount = holidaysById[id]?.size ?? 0;
        const suspensionCount = suspensionsById?.size ?? 0;

        const actualMinsIncurredRaw = minutesIncurredById[id];
        numberOfDuty = value[index]?.["OfDutyForCiaMciaBinocRangeTo1519"] ??
        dutyForCiaMciaBinoc[id] ?? [22];
        basicSalary = value[index]?.["basicSalary"] ?? basicSalaryAmount[id] ?? [salary];
  
        const actualMinsIncurred = Array.isArray(actualMinsIncurredRaw) && actualMinsIncurredRaw.length > 0
          ? actualMinsIncurredRaw.map((dateRangeArray, rangeIndex) => {
              const currentBasicSalary = Array.isArray(basicSalary)
                ? basicSalary[rangeIndex]
                : basicSalary;
              const currentNumberOfDuty = Array.isArray(numberOfDuty) ? numberOfDuty[rangeIndex] : numberOfDuty;
              
              const accumulated = dateRangeArray.reduce((sum, minsIncurredItem) => {
                const calculated = calculateTotalFromMins(minsIncurredItem, currentBasicSalary, currentNumberOfDuty);
                return sum + calculated;
              }, 0);
              
              return accumulated;
            })
          : [];


          const fixed =
          Array.isArray(actualMinsIncurred) && actualMinsIncurred.length > 0
            ? actualMinsIncurred.map((v) => Number(parseFloat(v).toFixed(2)))
            : actualMinsIncurred;

        // const count = getActualAttendanceDates(workingDates, totalAbsences);

        const actualDaysEarned = calculateArray(workingDaysCount, [   
           { type: "-", value: totalAbsences },
           ...(!isTwelveOrNine
            ? [
                { type: "-", value: holidayCount },
                { type: "-", value: suspensionCount },
              ]
            : []),
          ]);

          const newDaysEarned = actualDaysEarned.map(value =>
            Math.max(0, Math.min(22, value))
          );

        inService = newDaysEarned;


        proratedRate = calculateArray(basicSalary, [
          { type: "*", value: inService },
          { type: "/", value: numberOfDuty },
        ]);

        minsToBeDeduc = minsToBeDeducted[id];
        absMins = fixed;
        // absMins = calculateArray(salary, [
        //   { type: "/", value: 22 },
        //   { type: "/", value: count },
        //   { type: "/", value: 60 },
        //   { type: "*", value: minsToBeDeduc },
        // ]);

        const deducAbsMins = calculateArray(basicSalary, [
          { type: "/", value: 22 },
          { type: "*", value: inService },
          { type: "-", value: absMins },
        ]);

        const sumForEarned =
          deducAbsMins?.reduce((total, num) => total + num, 0) || 0;
        earned = sumForEarned;

        const twentyPercentValue = calculate(earned, [
          { type: "multiply", value: 0.2 },
        ]);

        twentyPercent = value[index]?.["20"] ?? twentyPercentValue ?? [0];

        
      }

      // const perDay = calculate(salary, [{ type: "divide", value: 22 }]);
      // const perMinute = calculate(salary, [
      //   { type: "divide", value: 22 },
      //   { type: "divide", value: 10.5 },
      //   { type: "divide", value: 60 },
      // ]);

      // const absDays = calculate(perDay, [
      //   { type: "multiply", value: daysTobeDeduc },
      // ]);

      const totalEarned = calculate(earned, [
        { type: "add", value: twentyPercent },
        { type: "add", value: gratuityPay },
      ]);

      if (isGrad) {
        threePercent = calculate(totalEarned, [
          { type: "multiply", value: 0.03 },
        ]);
      }

      // const joTax = calculateJOTax(
      //   salary,
      //   monthIndex,
      //   gratuityAllowance[id],
      //   0
      // );

      // if (percentTag === "2%" && isAnnexSubmitted) {
      //   twoPercent = calculate(joTax, [
      //     { type: "divide", value: monthIndex },
      //     { type: "multiply", value: 0.02 },
      //   ]);
      // }

      if (payItems === "Initial") {
        netAmount = calculate(totalEarned, [
          { type: "subtract", value: threePercent },
          // { type: "subtract", value: twoPercent },
        ]);
      } else {
        // const groupedTotalEarned = groupAndSumByMonth(
        //   totalEarned,
        //   monthNamesArr[id]
        // );

        netAmount = calculateArray(
          [totalEarned],
          [{ type: "-", value: [threePercent] }]
        );

        // netAmount = groupedTotalEarned.map((item, index) => {
        //   return `${item?.month} - ${netPayValues[index]}`;
        // });
      }

      eleventhCaseLists[id] = {
        salary: basicSalary,
        salaryValue: salary,
        numberOfDuty,
        // perDay,
        // perMinute,
        daysTobeDeduc,
        minsToBeDeduc,
        proratedRate,
        gratuityPay,
        // absDays,
        absMins,
        inService,
        earned,
        twentyPercent,
        threePercent,
        twoPercent,
        totalEarned,
        netAmount,
      };
    } else if (twelveCase) {
      const percentage = otherInfo?.percentage;
      const amountForAugmented = extractSalary(natureOfFunction);

      const assignObject = numberOfDutiesinAP?.assignObject?.[id] ?? {};
      const assignedTwentyFourSeven = parseTwentyFourSevenHours(
        assignObject?.twentyFourSeven
      );

      const minsDeducForAirport = createLookup(updatedObj, "id", "latesUt2");
      const daysDeducForAirport = createLookup(updatedObj, "id", "abs2");
      const noOfDutiesInAirport = createLookup(updatedObj, "id", "noOfDuties");
      const absentDatesAirport = createLookup(updatedObj, "id", "absentDatesAirport");
      const apRateAmount_1 = createLookup(updatedObj, "id", "payCode");
      const leaveWithoutPaySetArray = leaveWithoutPaySetArrayById[id];

      const year = extractYearMonth(monthNamesArr[id], "year");
      const month = extractYearMonth(monthNamesArr[id], "month");

      const apRateValue = calculate(percentage, [
        { type: "multiply", value: payCode },
        { type: "divide", value: 100 },
      ]);

      // const apRate = value[index]?.["apRate"] ?? apRateAmount[id] ?? [payCode];

      const apRate = value[index]?.["apRate"] ?? apRateAmount[id] ??[apRateValue];
      const late = lateCount[id];

      const absentbyid = absentDatesById[id];

      const datesOfAbsence = formatAbsenceDates(absentDatesById[id], leaveWithoutPaySetArray);
      const datesOfAbsenceAirport = formatAbsenceDates(absentDatesAirport[id]);
      const dateOfFlagRaising = dateOfFlagRaisingById[id];

      let flag = [];
      let datesOfFlagRaising = [];
      if (section === "20862f43-135d-4c4d-a080-a5f0d97f18c6" || section === "32b20f1c-3040-4778-9807-b5008950fa4f") {
        flag = calculateArray(late, [
        { type: "*", value: 500 },
      ]);
       datesOfFlagRaising = formatAbsenceDates(dateOfFlagRaising);
      }else{
        flag = [0];
      }

      const hasFlagLength = flag.length > 0 ? flag : ['']

      // const presentWorkDaysByIndex = workingDaysSetArray.map((days, idx) => {
      //   const absSet = absences[idx] || new Set();
      //   const result = [];
      //   for (const date of days) {
      //     if (!absSet.has(date)) {
      //       result.push(date);
      //     }
      //   }
      //   return result;
      // });

      // const lengths = presentWorkDaysByIndex.map(arr =>
      //   Math.min(arr.length, 22)
      // );

      // const params = {
      //   id,
      //   workDays,
      //   absentDateByEmployee,
      // };

      // const inServiceCount = getInServiceCount(params);

      // const periodRange = periodCount[id];
      const ciaMciaBinoc = value[index]?.["OfDutyForCiaMciaBinocRangeTo1519"] ??
        dutyForCiaMciaBinoc[id] ?? [22];
      const ciaMciaBinoc2 = value[index]?.["OfDutyForCiaMciaBinocRangeTo15192"] ??
        dutyForCiaMciaBinoc2[id] ?? [getDefaultOfDuty(assignObject)];

      const noOfDuties = noOfDutiesInAirport[id] || [];
      const minsTobeDeducCurrAss = minsDeducForReg[id];
      const daysTobeDeducCurrAss = daysDeducForReg[id];

      const workingDaysCount = workingDaysCountById[id];

         const totalDaysDuty = workingDaysCount
     
      //no need to deduct absent (July 31, 2026 - modified)
      // const totalDaysDuty = calculateArray(workingDaysCount, [
      //   { type: "-", value: daysTobeDeducCurrAss },
      // ]);

      const minsTobeDeducAirport = minsDeducForAirport[id];
      const daysTobeDeducAirport = daysDeducForAirport[id];
      const overPayment = ovrPayment[id];
      // const flagraising = flgRaising[id];
      const excessAirportDuty = excessAirport[id];
      const overpayment = value[index]?.["overpayment"] ?? overPayment ?? [0];
      const flagRaising = value[index]?.["flagRaising"] ?? hasFlagLength;

      const divisor = calculateArray(ciaMciaBinoc, [
        { type: "-", value: daysTobeDeducCurrAss },
      ]);

      const excessAirportDuties = value[index]?.["excessAirportDuties"] ??
        excessAirportDuty ?? [0];
      const taxes = updatedTax[id];
      const tax = value[index]?.["tax"] ?? taxes ?? [0];


      const minutesIncurredCurrAssRaw = minutesIncurredById[id] ?? [];

      // let apRateForBackPay;
      // if (Array.isArray(periodRange)) {
      //   apRateForBackPay = calculateBackPay(apRate, count);
      // }

      const apRateForBackPay = calculateArray(apRate, [
        { type: "/", value: ciaMciaBinoc },
        // { type: "*", value: divisor },
      ]);

      const ratePerDayRaw = apRate.map((rate, index) => rate / ciaMciaBinoc[index]);//no need to round off for rate per day

      const proratedApRate = calculateArray(ratePerDayRaw, [
        // { type: "-", value: noOfDuties },
        // { type: "*", value: apRateForBackPay },
        // { type: "/", value: ciaMciaBinoc },
        { type: "*", value: totalDaysDuty },
      ]);


      const absenceLeavesCurAss = calculateArray(ratePerDayRaw, [
        // { type: "/", value: ciaMciaBinoc }, since absent is remove in total days duty(July 31, 2026 - modified)
        { type: "*", value: daysTobeDeducCurrAss },
      ]);


      // const latesUtCurAss = calculateArray(apRate, [
      //   { type: "/", value: ciaMciaBinoc },
      //   { type: "/", value: assignedHours },
      //   { type: "/", value: 60 },
      //   { type: "*", value: minsTobeDeducCurrAss },
      // ]);

      const latesUtCurAss = minutesIncurredCurrAssRaw.map(
        (dateRangeArray, rangeIndex) => {
          const currentApRate = apRate[rangeIndex];
          const currentNumberOfDuty = ciaMciaBinoc[rangeIndex];

          if (!dateRangeArray.length) return 0;

          const accumulated = dateRangeArray.reduce(
            (sum, minsIncurredItem) =>
              sum +
              calculateTotalFromMins(
                minsIncurredItem,
                currentApRate,
                currentNumberOfDuty
              ),
            0
          );

          return Number(accumulated.toFixed(2));
        }
      );

      const earnedCurrAss = calculateArray(proratedApRate, [
        { type: "-", value: absenceLeavesCurAss },
        { type: "-", value: latesUtCurAss },
      ]);

      const airportAugmentationRate = noOfDuties.map((duty) =>
        duty > 0 ? amountForAugmented : 0
      );

      const airportAugAmt = calculateArray(airportAugmentationRate, [
        { type: "/", value: 22 },
        { type: "*", value: noOfDuties },
      ]);

      const absencesLeavesAirport = calculateArray(airportAugmentationRate, [
        { type: "/", value: ciaMciaBinoc2 },
        { type: "*", value: daysTobeDeducAirport },
      ]);

      const lateUtAirportAss = calculateArray(airportAugmentationRate, [
        { type: "/", value: ciaMciaBinoc },
        { type: "/", value: assignedTwentyFourSeven},
        { type: "/", value: 60 },
        { type: "*", value: minsTobeDeducAirport },
      ]);

      const airportDutyEarned = calculateArray(airportAugAmt, [
        { type: "-", value: absencesLeavesAirport },
        { type: "-", value: lateUtAirportAss },
      ]);

      const totalEarned = calculateArray(earnedCurrAss, [
        { type: "+", value: airportDutyEarned },
        { type: "+", value: excessAirportDuties },
      ]);

      const netEarn = calculateArray(totalEarned, [
        { type: "-", value: overpayment },
        { type: "-", value: flagRaising },
      ]);

      const groupedNetEarned = groupAndSumByMonth(netEarn, monthNamesArr[id]);
      const groupedTax = groupAndSumByMonth(tax, monthNamesArr[id]);

      const netEarnedValues = groupedNetEarned.map((item) => item.value);
      const taxValues = groupedTax.map((item) => item.value);

      const netAmountValues = calculateArray(
        netEarnedValues,
        [
          { type: "-", value: taxValues },
          // { type: "-", value: matchCsv },
        ],
        { allowNegative: true }
      );


      const finalNetAmountValues = calculateArray(netAmountValues, [
        { type: "-", value: matchCsv },
      ]);

      const net = netEarnedValues.map((value, index) =>
        value <= 0 ? netAmountValues[index] : finalNetAmountValues[index]
      );

      let matchedCsvRow = null;
      let uploadedCsvRow = null;
      const toCheck = finalNetAmountValues.some((value) => value <= 0)
        if(toCheck){
          matchedCsvRow = getMatchedCsvRowByAgency(csv, agency);
        }else{
          matchedCsvRow = "restore";
          uploadedCsvRow = getMatchedCsvRowByAgency(csv, agency);
        }
      // const netAmount = groupedNetEarned.map((item, index) => {
      //   return `${item?.month} - ${netAmountValues[index]}`;
      // });


      twelveCaseLists[id] = {
        apRate,
        year,
        month,
        payCode,
        assignObject,
        totalDaysDuty,
        apRateForBackPay,
        ciaMciaBinoc,
        ciaMciaBinoc2,
        proratedApRate,
        absenceLeavesCurAss,
        datesOfAbsence,
        datesOfFlagRaising,
        datesOfAbsenceAirport,
        latesUtCurAss,
        earnedCurrAss,
        airportAugmentationRate,
        airportAugAmt,
        absencesLeavesAirport,
        lateUtAirportAss,
        airportDutyEarned,
        overpayment,
        flagRaising,
        excessAirportDuties,
        totalEarned,
        tax,
        netEarned: netEarn,
        matchedCsvRow,
        netAmount: net,
      };
    } else if (tirteenthCase) {
      const additional = sumallAdditional[agency];
      const deductions = sumallDeductions[agency];

      // const result = sumEarnedByMonthRange(earnedForThePeriod, monthFrom, monthTo);

      const netAmount = calculate(additional, [
        { type: "subtract", value: deductions },
      ]);
      tirteenthCaseLists[id] = {
        netAmount,
      };
    } else if (fourteenthCase) {
      // const additional = sumallAdditional[agency];
      // const deductions = sumallDeductions[agency];

      const earnedResult = sumEarnedByMonthRange(
        earnedForThePeriod,
        monthFrom,
        monthTo
      );

      const earnedFrom = earnedResult[monthFrom] ?? 0;
      const earnedTo = earnedResult[monthTo] ?? 0;

      const totalEarned = calculate(earnedFrom, [
        { type: "add", value: earnedTo },
      ]);

      const twentyPercent = calculate(totalEarned, [
        { type: "multiply", value: 0.2 },
      ]);

      let threePercent = 0;
      if (isGraduated === "YES") {
        threePercent = calculate(twentyPercent, [
          { type: "multiply", value: 0.03 },
        ]);
      } else {
        threePercent = 0;
      }

      const netAmount = calculate(twentyPercent, [
        { type: "subtract", value: threePercent },
      ]);

      const year = otherInfo?.twentyPercentYear;

      fourteenthCaseLists[id] = {
        earnedFrom,
        earnedTo,
        totalEarned,
        twentyPercent,
        year,
        threePercent,
        netAmount,
      };
    }
  }

  return {
    ...(firstCase && { firstCaseLists }),
    ...(secondCase && { secondCaseLists }),
    ...(thirdCase && { thirdCaseLists }),
    ...(fourthCase && { fourthCaseLists }),
    ...(fifthCase && { fifthCaseLists }),
    ...(sixthCase && { sixthCaseLists }),
    ...(seventhCase && { seventhCaseLists }),
    ...(eightCase && { eightCaseLists }),
    ...(ninthCase && { ninthCaseLists }),
    ...(tenthCase && { tenthCaseLists }),
    ...(tenthCase && { tenthCaseLists }),
    ...(eleventhCase && { eleventhCaseLists }),
    ...(twelveCase && { twelveCaseLists }),
    ...(tirteenthCase && { tirteenthCaseLists }),
    ...(fourteenthCase && { fourteenthCaseLists }),
  };
};

const parseAndFormat = (value) => parseFloat(formattedRate(value.toString()));

function calculateJOTax(salary, monthIndex, allowances, totalEarnedForPeriod) {
  const forcastedSalary = salary * monthIndex;

  const addedPrevEarnedforPeriod = forcastedSalary + totalEarnedForPeriod;
  const twntyPercentForcasted = addedPrevEarnedforPeriod * 0.2;
  const forcastedAnnualIncome =
    addedPrevEarnedforPeriod + twntyPercentForcasted + allowances;

  let excessOfTwoFifthy = 0;
  if (forcastedAnnualIncome > 250000) {
    excessOfTwoFifthy = parseAndFormat(forcastedAnnualIncome - 250000);
  } else {
    excessOfTwoFifthy = 0;
  }

  return excessOfTwoFifthy;
}

function _getItemOldRate(oldRate, datePicked) {
  if (!Array.isArray(oldRate) || !datePicked?.startDate || !datePicked?.endDate)
    return [];
  const start = new Date(datePicked.startDate),
    end = new Date(datePicked.endDate);
  const monthYears = [];
  for (let d = new Date(start); d <= end; d.setMonth(d.getMonth() + 1))
    monthYears.push(
      `${d.toLocaleString("en-US", { month: "long" })} - ${d.getFullYear()}`
    );

  return oldRate.filter((entry) => monthYears.some((my) => entry.includes(my)));
}

function _getItemNewRate({
  salary,
  daysToBeDeducted = [],
  halfDaysToBeDeducted = [],
  minutesToBeDeducted = [],
}) {
  const monthlyTotals = {};

  const sumByMonth = (entries, calcFn) => {
    for (const entry of entries) {
      const parsed = parseEntry(entry);

      if (!parsed) continue;
      const { month, value } = parsed;
      const deduction = calcFn(value);
      if (!monthlyTotals[month]) monthlyTotals[month] = { totalDeduction: 0 };
      monthlyTotals[month].totalDeduction += deduction;
    }
  };

  // Full days
  sumByMonth(daysToBeDeducted, (val) => (salary * val) / 22);

  // Half days
  sumByMonth(halfDaysToBeDeducted, (val) => (salary * val) / 22 / 2);

  // Minutes
  sumByMonth(minutesToBeDeducted, (val) => (salary * val) / 22 / 8 / 60);

  // Final: subtract totalDeduction from salary
  const result = {};
  for (const month in monthlyTotals) {
    const deduction = monthlyTotals[month].totalDeduction;
    result[month] = parseFloat((salary - deduction).toFixed(2));
  }

  return result;
}

function _getSalaryDiff(itemForOldRate, itemForNewRate) {
  let totalDiff = 0;

  for (const entry of itemForOldRate) {
    const parsed = parseEntry(entry);
    if (!parsed) continue;

    const { month, value: oldValue } = parsed;
    const newValue = itemForNewRate[month] ?? 0;
    const diff = newValue - oldValue;

    totalDiff += diff;
  }

  return Number(totalDiff.toFixed(2));
}

const parseEntry = (entry) => {
  const match = entry.match(/\((\w+)\s*-\s*\d+\)\s*-\s*([\d.]+)/);
  if (!match) return null;
  const [_, month, value] = match;
  return { month, value: parseFloat(value) };
};

function getGsisOldRate(arr, type) {
  if (!Array.isArray(arr) || !type) return 0;
  return arr.reduce((sum, entry) => {
    const regex = new RegExp(`\\(${type}\\):\\s*([\\d.]+)`);

    const match = entry.match(regex);
    const value = match ? parseFloat(match[1]) : 0;
    return sum + value;
  }, 0);
}

function getGsisNewRate(
  gsisInsuredDays = [],
  daysInAmonth = [],
  salary,
  mandatoryFormula,
  mandatoryDeductions = [],
  type
) {
  const uniquePrefixesSet = new Set();
  for (let i = 0; i < mandatoryDeductions.length; i++) {
    const entry = mandatoryDeductions[i];
    const match = entry.match(/^(.+?)(?:\s*\(|:)/);
    if (match) uniquePrefixesSet.add(match[1].trim());
  }
  const uniquePrefixes = Array.from(uniquePrefixesSet);

  if (!salary || !Array.isArray(mandatoryDeductions) || !type) return 0;
  let total = 0;
  const expression = mandatoryFormula?.[type];

  const extractMonthYear = (str) => {
    const match = str.match(/([A-Za-z]+\s-\s\d{4})/);
    return match ? match[1] : null;
  };

  const extractValue = (str) => {
    const match = str.match(/:\s*([\d.]+)/);
    return match ? parseFloat(match[1]) : 0;
  };

  uniquePrefixes.forEach((entry) => {
    const monthYear = extractMonthYear(entry);

    if (!entry) return;
    if (type === "gsisLR") {
      if (entry.includes("General Payroll")) {
        total += calculateAmount(expression, salary);
      } else {
        const insuredEntry = Array.isArray(gsisInsuredDays)
          ? gsisInsuredDays.find((e) => e.startsWith(entry))
          : null;

        const daysInMonthEntry = Array.isArray(daysInAmonth)
          ? daysInAmonth.find((e) => e.startsWith(monthYear))
          : null;

        const insuredDays = insuredEntry ? extractValue(insuredEntry) : 0;

        const daysInMonth = daysInMonthEntry
          ? extractValue(daysInMonthEntry)
          : 0;
        if (insuredDays && daysInMonth) {
          const firstCalc = (salary * insuredDays) / daysInMonth;

          const result = firstCalc * 0.09;

          total += result;
        }
      }
    } else if (type === "phic") {
      total += calculateAmount(expression, salary);
    }
  });
  return Math.round(total * 100) / 100;
}

const parseEarnedForPeriodEntry = (entry) => {
  if (entry == null) return null;

  if (typeof entry === "string") {
    const colonIndex = entry.lastIndexOf(":");
    if (colonIndex === -1) return null;

    const label = entry.slice(0, colonIndex).trim();
    const amount =
      parseFloat(entry.slice(colonIndex + 1).trim().replace(/,/g, "")) || 0;

    return { label, amount };
  }

  if (typeof entry === "object") {
    const label = Object.keys(entry)[0];
    if (!label) return null;

    const amount = parseFloat(Object.values(entry)[0]) || 0;
    return { label, amount };
  }

  return null;
};

const sumEarnedByMonthRange = (earnedForThePeriod = [], monthFrom, monthTo) => {
  const monthOrder = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const fromIndex = monthFrom ? monthOrder.indexOf(monthFrom) : 0;
  const toIndex = monthTo ? monthOrder.indexOf(monthTo) : 11;

  // Fallback: if both are invalid, return total sum of all months
  const isFromValid = fromIndex !== -1;
  const isToValid = toIndex !== -1;

  const totals = {
    [monthFrom || "defaultFrom"]: 0,
    [monthTo || "defaultTo"]: 0,
  };

  earnedForThePeriod.forEach((entry) => {
    const parsed = parseEarnedForPeriodEntry(entry);
    if (!parsed) return;

    const { label, amount } = parsed;
    const match = label.match(/\((.*?)\s*-\s*(\d{4})\)/);
    if (!match) return;

    const month = match[1].trim();
    const index = monthOrder.indexOf(month);
    if (index === -1) return;

    // Skip if fromIndex > toIndex
    if (isFromValid && isToValid && fromIndex > toIndex) return;

    if (index >= fromIndex && index <= toIndex) {
      if (month === monthFrom) {
        totals[monthFrom] += amount;
      } else if (month === monthTo) {
        totals[monthTo] += amount;
      }
    }
  });

  return {
    [monthFrom || "monthFrom"]: totals[monthFrom || "defaultFrom"],
    [monthTo || "monthTo"]: totals[monthTo || "defaultTo"],
  };
};

const calculateTotalFromMins = (
  { totalLateUTMins, twentyFourSeven },
  apRate,
  numberOfDuty = 22,
  defaultHoursPerDay
) => {
  if ((!totalLateUTMins || totalLateUTMins < 0) && totalLateUTMins !== 0) return 0;

  const rate = Number(apRate);
  const duty = Number(numberOfDuty);
  if (!Number.isFinite(rate) || rate <= 0 || !Number.isFinite(duty) || duty <= 0) return 0;

  // Explicit 4th arg wins. Otherwise parse twentyFourSeven, else fall back to 12.
  let hoursPerDay = defaultHoursPerDay;
  if (hoursPerDay == null) {
    if (typeof twentyFourSeven === "string") {
      const match = twentyFourSeven.match(/([\d.]+)\s*Hours?/i);
      if (match) {
        hoursPerDay = parseFloat(match[1]);
      }
    }
    if (hoursPerDay == null) {
      hoursPerDay = 12;
    }
  }

  const dailyRate = rate / duty / hoursPerDay;
  const perMinuteRate = dailyRate / 60;
  const value = perMinuteRate * totalLateUTMins;

  // truncate to 2 decimal places instead of rounding
  return value;
};
